import { Toolbar } from "@material-ui/core";
import { useHistory } from "react-router";
import AccountButton from "./account-button";
import { AppBar as BaseAppBar, AppBarTitle } from "./app-bar.styles";

export type AppBarProps = {
  title: string | undefined;
  renderLeftComponent?: () => JSX.Element | null | undefined;
  renderRightComponent?: () => JSX.Element | null | undefined;
};

const AppBar = ({
  title,
  renderLeftComponent,
  renderRightComponent = () => null,
}: AppBarProps) => {
  const history = useHistory();

  const handleOpenAccount = () => {
    history.push("/account");
  };

  return (
    <BaseAppBar>
      <Toolbar>
        {renderLeftComponent ? (
          renderLeftComponent()
        ) : (
          <AccountButton onClick={handleOpenAccount} />
        )}
        <AppBarTitle>{title}</AppBarTitle>
        {renderRightComponent()}
      </Toolbar>
    </BaseAppBar>
  );
};
export default AppBar;
